(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fascino-all", [], factory);
	else if(typeof exports === 'object')
		exports["fascino-all"] = factory();
	else
		root["fascino-all"] = factory();
})(self, () => {
return 